import React from 'react';
import useContactForm from '../hooks/useContactForm';

interface ContactFormProps {
  title?: string;
  description?: string;
}

const ContactForm: React.FC<ContactFormProps> = ({
  title = 'Contact Us',
  description = "We're here to help with your real estate needs. Fill out the form below and we'll get back to you promptly."
}) => {
  const {
    formData,
    emailError,
    phoneError,
    isSubmitting,
    formMessage,
    isFormValid,
    handleChange,
    handleSubmit
  } = useContactForm();

  return (
    <div className="contact-form" data-cms-section="contactForm">
      <h2 data-cms-field="title">{title}</h2>
      <p className="form-description" data-cms-field="description">{description}</p>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
              autoComplete="given-name"
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
              autoComplete="family-name"
            />
          </div>
        </div>
        <div className="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            autoComplete="email"
            className={emailError ? 'error' : ''}
          />
          {emailError && <span className="error-message">{emailError}</span>}
        </div>
        <div className="form-group">
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            autoComplete="tel"
            className={phoneError ? 'error' : ''}
          />
          {phoneError && <span className="error-message">{phoneError}</span>}
        </div>
        <div className="form-group">
          <textarea
            id="message"
            name="message"
            rows={5}
            placeholder="Tell us about your real estate needs"
            value={formData.message}
            onChange={handleChange}
            required
            autoComplete="off"
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary btn-submit"
          disabled={!isFormValid || isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
        <p className="recaptcha-notice">
          This site is protected by reCAPTCHA.
        </p>
        {formMessage.text && (
          <p className={`form-feedback ${formMessage.type}`}>{formMessage.text}</p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
